import { cn } from "@/lib/utils";
import { HTMLAttributes, ReactNode } from "react";

interface Props extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function NotificationBadge({ children, className, ...props }: Props) {
  return (
    <div
      {...props}
      className={cn(
        "flex items-center justify-center w-4 h-4 text-black text-xs font-bold bg-brand-primary rounded-full p-1",
        className
      )}
    >
      {children}
    </div>
  );
}
